import React from 'react';
import EmElaboracao from './EmElaboracao';

export default function GestaoMonitoramentoClinico() {
  return (
    <EmElaboracao
      title="Gestão de Monitoramento Clínico"
      description="Acompanhamento clínico contínuo e evolução dos pacientes em homecare."
      icon="📊"
      section="Homecare"
    />
  );
}
